import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import { checkForAuthorization } from "utilities/index"
import { RetryOnError, verifyToken } from "utilities/VerifyToken"

// Real engagement numbers behind the Key Metrics card and the Profile Views
// cards. The backend zeroes every value when the startup has no active plan, so
// `is_subscribed` is what drives the blur/upsell treatment rather than the
// numbers themselves.
export const FetchStartupEngagementSummary = ({ id: startup_id, days = 30, enabled = true }) => {
    return useQuery(
        ['startup-engagement-summary-fetch' + startup_id, startup_id, days],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startups/engagement/summary/${startup_id}?days=${days}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        select: (data) => data?.data?.data,
        enabled: Boolean(enabled) && Boolean(startup_id),
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}
